import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import SideBar from '../DashboardComponents/CommonComponents/SideBar'
import TopBar from '../DashboardComponents/CommonComponents/TopBar'
import "./css/Dashboard.css"
import PageNotFound from "../CommonComponents/PageNotFound"

import {
        withRouter,
        BrowserRouter as Router,
        Switch,
        Route,
        Redirect
} from "react-router-dom";
import DataCleaningTab from "../DashboardComponents/Tabs/DataCleaningTab"
import ExtrapolationTab from '../DashboardComponents/Tabs/ExtrapolationTab'
import GuideTab from '../DashboardComponents/Tabs/GuideTab'
import NotebookGenerationTab from '../DashboardComponents/Tabs/NotebookGenerationTab'
import PreprocessingTab from '../DashboardComponents/Tabs/PreprocessingTab'
import ReportGenerationTab from '../DashboardComponents/Tabs/ReportGenerationTab'
import StatisticalAnalysisTab from '../DashboardComponents/Tabs/StatisticalAnalysisTab'
import StudyMaterialTab from '../DashboardComponents/Tabs/StudyMaterialTab'
import VisualizationsTab from '../DashboardComponents/Tabs/VisualizationsTab'

import { FetchSingleProjectService } from "../../Services/DjangoServices"

class Dashboard extends Component {
        constructor(props) {
                super(props)
                this.state = {
                        project_found: false,
                        email_verified: true,
                        details: {
                                email: null,
                                username: null,
                                first_name: null,
                                log_out: false
                        },
                        current_project_key: null,
                        datasets: null,
                        projects: null,
                        selected_dataset: null
                }
        }
        logout() {
                window.localStorage.removeItem('auth-token');
                window.location.replace('/');
        }
        componentDidMount() {
                var project_key_name = window.location.href.split("/").slice(-1).pop()
                var body = { "project_key_name": project_key_name }
                FetchSingleProjectService(body).then((result) => {
                        result.json().then((data) => {
                                if ("not_authenticated" in data){
                                        this.logout();
                                }
                                if ("found" in data){
                                        this.setState({
                                                project_found: true,
                                                projects: data["other_projects"],
                                                current_project_key: project_key_name,
                                                datasets: data["datasets"],
                                                selected_dataset: Object.keys(data["datasets"])[0],
                                                selected_dataset_name: data["datasets"][Object.keys(data["datasets"])[0]]
                                        })
                                }
                        })
                });
        }
        componentWillUnmount() {
                this._isMounted = false;
        }

        changeDataset(target){
                var index = target.selectedIndex;
                var optionElement = target.childNodes[index]
                var dataset_key = optionElement.getAttribute('data_key')
                this.setState({
                        selected_dataset: dataset_key,
                        selected_dataset_name: this.state.datasets[dataset_key]
                })
        }

        render() {
                return (
                        <React.Fragment>
                                {this.state.project_found ?
                                        <div id="main-dashboard-container">
                                                <Router>
                                                        <SideBar datasets={this.state.datasets} current_project_key={this.state.current_project_key} changeDataset={(dataset) => {this.changeDataset(dataset)}}/>
                                                        <div id="dashboard-inner">
                                                                <TopBar projects={this.state.projects} current_project_key={this.state.current_project_key}/>
                                                                <div id="inner-tab">
                                                                        <Switch>
                                                                                <Route path={`${this.props.match.url}/preprocessing/:project_key`} render={(props) => <PreprocessingTab {...props} selected_dataset_url={this.state.selected_dataset} selected_dataset_name={this.state.selected_dataset_name}/>}>
                                                                                </Route>
                                                                                <Route path={`${this.props.match.url}/visualizations/:project_key`} render={(props) => <VisualizationsTab {...props} selected_dataset_url={this.state.selected_dataset} selected_dataset_name={this.state.selected_dataset_name}/>}>
                                                                                </Route>
                                                                                <Route path={`${this.props.match.url}/report_generation/:project_key`} render={(props) => <ReportGenerationTab {...props} selected_dataset_url={this.state.selected_dataset} selected_dataset_name={this.state.selected_dataset_name}/>} >
                                                                                </Route>
                                                                                <Route path={`${this.props.match.url}/notebook_generation/:project_key`} render={(props) => <NotebookGenerationTab  {...props} selected_dataset_url={this.state.selected_dataset} selected_dataset_name={this.state.selected_dataset_name}/>} >
                                                                                </Route>
                                                                                <Route path={`${this.props.match.url}/guide/:project_key`} render={(props) => <GuideTab  {...props} selected_dataset_url={this.state.selected_dataset} selected_dataset_name={this.state.selected_dataset_name}/>}>
                                                                                </Route>
                                                                                <Route path={`${this.props.match.url}/extrapolation/:project_key`} render={(props) => <ExtrapolationTab  {...props} selected_dataset_url={this.state.selected_dataset} selected_dataset_name={this.state.selected_dataset_name}/>}>
                                                                                </Route>
                                                                                <Route path={`${this.props.match.url}/data_cleaning/:project_key`} render={(props) => <DataCleaningTab  {...props} selected_dataset_url={this.state.selected_dataset} selected_dataset_name={this.state.selected_dataset_name}/>}>
                                                                                </Route>
                                                                                <Route path={`${this.props.match.url}/statistical_analysis/:project_key`} render={(props) => <StatisticalAnalysisTab  {...props} selected_dataset_url={this.state.selected_dataset} selected_dataset_name={this.state.selected_dataset_name}/>}>
                                                                                </Route>
                                                                                <Route path={`${this.props.match.url}/study_materials/:project_key`} render={(props) => <StudyMaterialTab {...props} selected_dataset_url={this.state.selected_dataset} selected_dataset_name={this.state.selected_dataset_name}/>}>
                                                                                </Route>
                                                                                <Redirect exact to='/project/preprocessing/:project_key' />
                                                                        </Switch>
                                                                </div>
                                                        </div>
                                                </Router>
                                        </div>
                                        :
                                        <PageNotFound/>
                                }
                        </React.Fragment>
                )

        }
}


export default withRouter(Dashboard)


